import { gql } from '../gen';

export const ADD_CHILD = gql(`
  mutation AddChild($input: AddChildInput!) {
    addChild(input: $input) {
      id
      firstName
      lastName
      geneticSex
      birthDate
      deathDate
      userId
      familyTreeId
      partnerInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
      }
      childInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
      }
    }
  }
`);

export const ADD_PARENT = gql(`
  mutation AddParent($input: AddParentInput!) {
    addParent(input: $input) {
      id
      firstName
      lastName
      geneticSex
      birthDate
      deathDate
      userId
      familyTreeId
      partnerInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
        children {
          id
          firstName
          lastName
          geneticSex
        }
      }
      childInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
      }
    }
  }
`);

export const ADD_PARTNER = gql(`
  mutation AddPartner($input: AddPartnerInput!) {
    addPartner(input: $input) {
      id
      firstName
      lastName
      geneticSex
      birthDate
      deathDate
      userId
      familyTreeId
      partnerInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
        children {
          id
          firstName
          lastName
          geneticSex
        }
      }
      childInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
      }
    }
  }
`);

export const ADD_SIBLING = gql(`
  mutation AddSibling($input: AddSiblingInput!) {
    addSibling(input: $input) {
      id
      firstName
      lastName
      geneticSex
      birthDate
      deathDate
      userId
      familyTreeId
      partnerInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
        children {
          id
          firstName
          lastName
          geneticSex
        }
      }
      childInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
      }
    }
  }
`);

export const EDIT_PERSON = gql(`
  mutation EditPerson($input: EditPersonInput!) {
    editPerson(input: $input) {
      id
      firstName
      lastName
      geneticSex
      birthDate
      deathDate
      userId
      familyTreeId
      partnerInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
        children {
          id
          firstName
          lastName
          geneticSex
        }
      }
      childInFamilies {
        id
        status
        partners {
          id
          firstName
          lastName
          geneticSex
        }
      }
    }
  }
`);

export const REMOVE_PERSON = gql(`
  mutation RemovePerson($input: RemovePersonInput!) {
    removePerson(input: $input)
  }
`);

export const PROVISION_USER = gql(`
  mutation ProvisionUser {
    provisionUser {
      id
      email
      firstName
      lastName
      createdAt
    }
  }
`);

export const CALCULATE_RISK_SCORE = gql(`
  mutation CalculateRiskScore($responses: [UserResponseInput!]!) {
    calculateRiskScore(responses: $responses) {
      id
      userId
      totalScore
      assignedTier
      calculatedAt
    }
  }
`);

export const UPDATE_MDI_ONBOARDING_STARTED = gql(`
  mutation UpdateMdiOnboardingStarted {
    updateMdiOnboardingStarted {
      id
    }
  }
`);

export const UPDATE_MDI_ONBOARDING_COMPLETED = gql(`
  mutation UpdateMdiOnboardingCompleted {
    updateMdiOnboardingCompleted {
      id
    }
  }
`);

export const SEND_INVITATION = gql(`
  mutation SendInvitation($input: SendInvitationInput!) {
    sendInvitation(input: $input) {
      invitation {
        id
        email
        status
        createdAt
        personId
      }
    }
  }
`);

export const RESEND_INVITATION = gql(`
  mutation ResendInvitation($input: ResendInvitationInput!) {
    resendInvitation(input: $input) {
      invitation {
        id
        email
        status
        createdAt
        personId
      }
    }
  }
`);

export const RESPOND_TO_INVITATION = gql(`
  mutation RespondToInvitation($input: RespondToInvitationInput!) {
    respondToInvitation(input: $input) {
      invitation {
        id
        status
        acceptedAt
        declinedAt
      }
      treeMembership {
        id
        role
        userId
        treeId
      }
    }
  }
`);

export const CREATE_PROGRAMMATIC_USER = gql(`
  mutation CreateProgrammaticUser($input: CreateProgrammaticUserInput!) {
    createProgrammaticUser(input: $input) {
      success
    }
  }
`);
